import { useRef } from "react";
import { hayGateDeAltaActivo } from "../helpers/turno-lugares-gate";

// #1453 R12: memoria de la ENTRADA (el montaje del componente que la usa) de
// si en algún momento hubo un gate de alta VISIBLE (#1534: lo que dibuja un
// overlay, ver `hayGateDeAltaActivo`; quien ya dijo "Después" no tuvo ninguno).
// Es pegajosa a propósito: una vez en true no vuelve a false hasta el próximo
// montaje, así que cerrar el overlay del celular (al guardarlo, refreshUser
// trae `missing_profile_fields` sin `phone`) no le abre la puerta al
// formulario de primera unidad en la misma entrada. Se marca durante el render
// y no en un effect, para que el valor ya esté puesto cuando corra cualquier
// effect de ese mismo commit (Turno.js decide en un effect que puede correr en
// el mismo commit en que el gate se cierra). Marcar en render es idempotente:
// solo pasa de false a true.
export default function useHuboGateDeAlta(user) {
  const huboRef = useRef(false);
  if (!huboRef.current && hayGateDeAltaActivo(user)) huboRef.current = true;
  return huboRef.current;
}
